export class RegEx {
	static ALPHANUMERIC = '^[a-zA-Z0-9]*$';
	static NUMERIC = '^[0-9]*$';
	static CURRENCY = '^[0-9]*(.[0-9]{1,2})?$';
	static EMAIL = '^[^s@]+@[^s@]+.[^s@]+$';
	static PHONE = `^(0|64)(800|[34679]|[28][0-9])(?:[ )-]*[0-9]){6,8}$`;
	static LOYALTY_CARD = `^[0-9]{4}[-| ][0-9]{4}[-| ][0-9]{4,5}$`;
}
